export default "__VITE_ASSET__BiT95IXD__"